import React, { useEffect, useState } from 'react';

const BUBBLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 40 + 10,
  left: Math.random() * 100,
  delay: Math.random() * 2,
  duration: Math.random() * 3 + 3,
}));

export default function SplashScreen({ onDone }) {
  const [phase, setPhase] = useState('in'); // 'in' | 'hold' | 'out'

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase('out'), 2200);
    const doneTimer = setTimeout(() => onDone(), 3000);
    return () => { clearTimeout(holdTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center overflow-hidden"
      style={{
        opacity: phase === 'out' ? 0 : 1,
        transition: phase === 'out' ? 'opacity 0.8s ease-in-out' : 'none',
      }}
    >
      {/* Floating bubbles */}
      {BUBBLES.map((b) => (
        <div
          key={b.id}
          className="absolute rounded-full pointer-events-none"
          style={{
            width: b.size,
            height: b.size,
            left: `${b.left}%`,
            bottom: '-60px',
            background: 'radial-gradient(circle at 30% 30%, rgba(104,202,241,0.25), rgba(104,202,241,0.05))',
            border: '1px solid rgba(104,202,241,0.15)',
            animation: `bubble-rise ${b.duration}s ${b.delay}s ease-in infinite`,
          }}
        />
      ))}

      {/* Glow backdrop */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(104,202,241,0.07) 0%, transparent 70%)' }}
      />

      {/* Content */}
      <div
        className="relative z-10 flex flex-col items-center gap-6"
        style={{
          opacity: phase === 'in' ? 0 : 1,
          transform: phase === 'in' ? 'translateY(16px)' : 'translateY(0)',
          transition: 'opacity 0.7s ease-out 0.2s, transform 0.7s ease-out 0.2s',
        }}
      >
        <img
          src="/images/logo.png"
          alt="Monarch Detailing"
          className="h-24 w-auto object-contain drop-shadow-[0_0_24px_rgba(104,202,241,0.5)]"
        />
        <div className="text-center">
          <p className="text-white font-bold text-2xl tracking-[0.25em] uppercase">Monarch Detailing</p>
          <p className="text-[#68caf1] text-sm tracking-[0.35em] uppercase mt-1">Automotive Alchemy</p>
        </div>
      </div>

      <style>{`
        @keyframes bubble-rise {
          0%   { transform: translateY(0) scale(1); opacity: 0; }
          10%  { opacity: 1; }
          90%  { opacity: 0.6; }
          100% { transform: translateY(-110vh) scale(1.1); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
